/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const evaluateChallengeResponseSchema = z.object({
  qualityScore: z.number().min(1).max(10),
  suggestedForm: z.string().nullable(),
  qualityReasoning: z.string(),
});

export type IEvaluateChallengeResponse = z.infer<typeof evaluateChallengeResponseSchema>;
